<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>
            <v-tab :ripple="true"> پیش نمایش </v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <div class="rowinfo">
                  <!-- <v-btn class="btn-download" @click="showDialog = true">
                    <v-icon>mdi-progress-download</v-icon>
                    {{ $t("download_qr") }}                  </v-btn> -->
                  <help-info
                    :element-name="`${serviceName}-${componentName}-download`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="دانلود کیوآر"
                  />
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <!-- اعمال بایندینگ دوطرفه برای ترتیب چیدمان بخش‌ها -->
              <gallery-mobile v-model="cardTexts" :orders.sync="cardTexts.orders" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات کیوآر کد قاب خاطره</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="عنوان هدیه شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام مدل قاب خاطره"
                  />
                </div>

              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6=2"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                @close="showDialog = false"
                :qr_id="info?.qrId"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import GalleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { Bus } from "@/main";

export default {
  name: "giftGalleryModel",

  components: {
    QrCodeMake,
    DownloadFileWithApi,
    NextBtn,
    ListExpansion,
    QrAddressField,
    GalleryMobile,
    QrMaker,
  },

  data() {
    return {
      introText: `
        <strong>کیوآر قاب خاطره‌ها</strong> یک هدیه دیجیتال و جذاب برای ثبت و مرور زیباترین لحظات شماست. با این کیوآر می‌توانید یک صفحه اختصاصی و ماندگار از خاطرات مشترکتان بسازید.
        <br><br>
        <strong>امکانات این صفحه:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. گالری تصاویر و ویدیو:</strong> عکس‌ها و ویدیوهای خاطره‌انگیز خود را آپلود کنید.<br>
          <strong>۲. تایم‌لاین خاطرات:</strong> تاریخ‌های مهم (مثل روز آشنایی، سالگرد و...) را با متن دلخواه ثبت کنید.<br>
          <strong>۳. پیام صوتی و موسیقی:</strong> آهنگ موردعلاقه یا یک پیام صوتی ویژه به صفحه اضافه کنید.
        </span>
        <br>
        این کیوآر بهترین سورپرایز و هدیه برای عزیزانتان در مناسبت‌های خاص است.
      `,
      helpData: [],
      serviceName: "Qrland",
      componentName: "giftGallery",
      e6: 1,
      qrShow: 1,
      domainId: null,
      info: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: false,
      loading: false,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts:
       {
  visitName: "لحظه ای برای همیشه",
  orders: [
    { name: 'profile' },
    { name: 'organizationInfo' },
    { name: 'headerImage' },
    { name: 'memories' }, 
    { name: 'gallery' },
    { name: 'video_gallery' },
    { name: 'audiosGallery' },
    { name: 'website' },
    { name: 'aboutUs' },

    // { name: 'showInfo' }
  ],
  memories: [
    { title: "اولین نگاه و آشنایی", date: '1404/04/04' },
    { title: "سفر خاطره‌انگیز شمال", date: '1404/06/15' },
    { title: "جشن سالگرد رویایی", date: '1405/04/22' },
    { title: "آغاز فصل جدید زندگی", date: '1405/05/10' }
  ],
  banner: {
    mode: "grid", //grid|slider
    gallery: [
      {
        images: [
          {
            name: "تصویر ۱",
            title: "",
            url: "https://cdn.terminalads.com/upload/6a536f644717b.webp",
            description: "",
            link: "",
            id: 1949198,
          },
          {
            name: "تصویر ۲",
            title: "",
            url: "https://cdn.terminalads.com/upload/6a536effc4422.webp",
            description: "",
            link: "",
            id: 1949195,
          },
          {
            name: "تصویر ۳",
            title: "",
            url: "https://cdn.terminalads.com/upload/6a536f2231941.webp",
            description: "",
            link: "",
            id: 1949197,
          },
        ],
        name: "خاطرات در یک نگاه",
      },
    ],
  },
  pallete: {
    headColor: "linear-gradient(135deg, #2D0C3F 0%, #5B1647 100%)",
    bodyColor: "linear-gradient(180deg, #1A0826 0%, #0F0418 100%)",
    textColor: "#ffffff",
    borderColor: "#4A1B38",
  },
  extraFields: [
    {
      icon: "",
      name: "",
      value: "",
    },
  ],
  gallery: [
    {
      name: "لحظات دونفره",
      images: [
        {
          name: "عاشقانه ۱",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536f2643567.webp",
          description: "",
          link: "",
          id: 1949196,
        },
        {
          name: "عاشقانه ۲",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536f2231941.webp",
          description: "",
          link: "",
          id: 1949199,
        },
      ],
    },
    {
      name: "آلبوم اختصاصی",
      images: [
        {
          name: "یادگاری ۱",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536f250336a.webp",
          description: "",
          link: "",
          id: 1949200,
        },
        {
          name: "یادگاری ۲",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536effc4422.webp",
          description: "",
          link: "",
          id: 1949202,
        },
        {
          name: "یادگاری ۳",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536f2396021.webp",
          description: "",
          link: "",
          id: 1949201,
        },
        {
          name: "یادگاری ۴",
          title: "",
          url: "https://cdn.terminalads.com/upload/6a536effc4422.webp",
          description: "",
          link: "",
          id: 1949203,
        },
      ],
    },
  ],
  photo: {
    profile: "",
    transition: "scale",
    hasWelcome: false,
    showWelcome: false,
    hasGif: false,
    hasGame: false,

    previewerQr: {
      previewer: {
        gif: "",
        game: {},
        transition: "scale",
      },
    },
  },
  audiosGallery: {
    audios: [
      {
        id: 1941300,
        category: "همه",
        title: "آهنگ خاطره ما",
        md5: "0cf572d4e658fe4ca5345f52677d08da",
        path: "upload/686a93cf44e5c.wav",
        image: "",
        type: "other",
        file_type: "audio",
        created_at: "2025-07-06T15:18:39.000000Z",
        updated_at: "2025-07-06T15:18:39.000000Z",
        full_path: "",
        created_at_p: "1404-04-15 18:48:39",
        updated_at_p: "1404-04-15 18:48:39",
        created_at_diff: "1 ثانیه پیش",
        updated_at_diff: "1 ثانیه پیش",
      },
    ],
    audioType: "newPlayer",
  },
  VideoGallery: {
    sectionColor: {
      backGround: "linear-gradient(to right, #4A1B38, #2D0C3F)",
      text: "#fff",
    },
    title: "ویدیوهای خاطره‌انگیز",
    description: "مرور خاطرات تصویری که همیشه لبخند به لبمان می‌آورد...\nلحظاتی که برای همیشه در قلب ما ثبت شده‌اند.\n",
    slider: false,
    grid: false,
    secondPosition: true,
    name: "جان جانانم بی تو هرگز",
    images: [
      {
        title: "",
        url: "https://www.aparat.com/video/video/embed/videohash/VdKgy/vt/frame",
        description: "مرور خاطرات تصویری که همیشه لبخند به لبمان می‌آورد...\nلحظاتی که برای همیشه در قلب ما ثبت شده‌اند.\n",
        link: "",
        cover_url:"",
      },
    ],
  },
  video_gallery: [
    {
      name: "جان جانانم بی تو هرگز",
      images: [
        {
          title: "",
          url: "https://www.aparat.com/video/video/embed/videohash/VdKgy/vt/frame",
          description: "مرور خاطرات تصویری که همیشه لبخند به لبمان می‌آورد...\nلحظاتی که برای همیشه در قلب ما ثبت شده‌اند.\n",
          link: "",
        },
      ],
    },
  ],
 aboutUs: `عزیزترینم،

بعضی از آدم‌ها وارد زندگی ما می‌شوند و با حضورشان، لحظه‌های معمولی را به خاطراتی فراموش‌نشدنی تبدیل می‌کنند. تو یکی از همان آدم‌های خاصی هستی که بودنش ارزشمند است و لبخندش می‌تواند یک روز ساده را زیباتر کند.

این هدیه کوچک را با تمام عشق و احساسی که در قلبم دارم برای تو آماده کردم؛ شاید یک گل، یک یادگاری یا یک لحظه کوتاه باشد، اما پشت آن دنیایی از محبت و حرف‌های ناگفته وجود دارد.

امیدوارم هر بار که این خاطره را می‌بینی، لبخندی روی لبانت بنشیند و به یاد بیاوری که کسی هست که برای خوشحالی تو اهمیت قائل است.

ممنونم که بخشی از زیباترین لحظه‌های زندگی من هستی. ❤️`,

  organizationName: "قاب خاطره‌های ماندگار",
  subtitle: "لحظاتی که در قلب زمان ثبت شدند؛ مرور زیباترین خاطرات با هم بودن ❤️",
  website: "با مهر و عشق، برای یک خاطره ماندگار 🌹",
  PicSelector: {
    title: "",
    description: "",
    sectionColor: {
      backGround: "linear-gradient(to right, #4A1B38, #2D0C3F)",
      text: "#fff",
    },
    slider: false,
    grid: true,
  },
  baseInfo: {
    sectionColor: {
      backGround: "linear-gradient(to right, #4A1B38, #2D0C3F)",
      text: "#fff",
    },
    slider: false,
    grid: false,
  },
  socialMedia: {},
},

      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "داستان هدیه",
          icon: "account-heart-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "تصویر پروفایل",
          icon: "camera-plus",
          model: "photo",
        },
        {
          name: "bannerSelector",
          value: "",
          title: "تصاویر منتخب",
          icon: "panorama",
          model: "banner",
        },
        { name: "PicSelector", value: "", title: "گالری تصویر", icon: "image-multiple" },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video",
        },
        {
          name: "voiceGallery",
          title: "افزودن فایل صوتی",
          icon: "microphone",
          model: "audiosGallery",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      qrSvgDataUrl: "",
    };
  },
  computed: {
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return "با مهر و عشق، برای یک خاطره ماندگار 🌹";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    imageUrl_1() {
      return this.$cdnUrl + "/upload/6a536f2231941.webp";
    },
    imageUrl_2() {
      return this.$cdnUrl + "/upload/6a536f2643567.webp";
    },
    imageUrl_3() {
      return this.$cdnUrl + "/upload/6a536f644717b.webp";
    },
    imageUrl_4() {
      return this.$cdnUrl + "/upload/6486cda4341fc.webp";
    },
    imageUrl_5() {
      return this.$cdnUrl + "/upload/6486cac9e99e1.webp";
    },
    imageUrl_6() {
      return this.$cdnUrl + "/upload/6486cf4c71122.webp";
    },
    imageUrl_7() {
      return this.$cdnUrl + "/upload/6486d1cad1870.webp";
    },
    imageUrl_8() {
      return this.$cdnUrl + "/upload/6a5372f78b4d3.webp";
    },
    imageUrl_9() {
      return this.$cdnUrl + "/upload/648703f54b008.webp";
    },
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.banner.gallery[0].images[0].url = this.imageUrl_1;
    this.cardTexts.banner.gallery[0].images[1].url = this.imageUrl_2;
    this.cardTexts.banner.gallery[0].images[2].url = this.imageUrl_3;
    this.cardTexts.gallery[0].images[0].url = this.imageUrl_4;
    this.cardTexts.gallery[0].images[1].url = this.imageUrl_5;
    this.cardTexts.gallery[1].images[0].url = this.imageUrl_6;
    this.cardTexts.gallery[1].images[1].url = this.imageUrl_7;
    this.cardTexts.gallery[1].images[2].url = this.imageUrl_8;
    this.cardTexts.gallery[1].images[3].url = this.imageUrl_9;
    this.cardTexts.audiosGallery.audios[0].image = this.roboatUrl;
    this.cardTexts.audiosGallery.audios[0].full_path = this.cdnUrl;

    this.cardTexts.photo.profile =
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.cardTexts.website = 'با مهر و عشق، برای یک خاطره ماندگار 🌹';
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "gift",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
         qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
          qr: obj,
          type: "gift",
          title: this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("مدل قاب خاطره شما با موفقیت ساخته شد.");
          if(final)
          this.$router.replace({ name: "modelsList" });
        })
        .catch((error) => {
          const response = error.response;
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
